import { LanguageKeys } from 'src/core/provider/AppMeta';

export default class VideoLanguage {
    readonly iso2: LanguageKeys;

    readonly availableVideoCount: number;

    constructor(json: any) {
        this.iso2 = json.iso2;
        this.availableVideoCount = json.availableVideoCount;
    }
}
